export default {"src":"/_next/static/media/book_text.a630dd65.svg","height":24,"width":25};